<template>
  <div>
    <div v-if="pageLoader"
         style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 25%; background-color: rgba(255, 255, 255, 0.31);">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>

    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg9>
        </v-flex>
        <v-flex xs12 sm12 md12 lg3>
          <v-flex xs12 sm12 md12 lg12 style="display: flex; justify-content: center; padding-bottom: 27px;">
            <v-btn v-on:click="create_match_object_dialog = true" slot="activator"
                   class="white--text text-xs-center"
                   style="padding: 22px; background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);">
              <v-icon v:v-on:clic color="#bbbbc6" class="white--text mr-2">edit</v-icon>
              Create IPL Match
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="table_opacity_8" style="padding-top: 10px;">
        <v-flex xs12>
          <v-data-table
              :items="iplMatchesList"
              item-key="id"
              class="elevation-1"
              :loading="loaders.IPL_matches_list"
              loading-text="Loading... Please wait"
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :pagination.sync="pagination"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]">

            <template v-slot:items="props">
              <tr>
                <td v-if="props.item.date">
                  <a v-on:click="showDetails(props.item.id)">{{ props.item.date }}</a>
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.team_1_name">
                  {{ props.item.team_1_name }} {{ "(" }}{{ props.item.team_1_shortname }} {{ ")" }}
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.team_2_name">
                  {{ props.item.team_2_name }} {{ "(" }}{{ props.item.team_2_shortname }} {{ ")" }}
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.match_order">
                  {{ props.item.match_order }}
                </td>
                <td v-else> {{ " - " }}</td>
                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on , attrs}">
                      <v-btn icon v-on="on"
                             v-bind="attrs" small
                             @click.prevent="getMatchDetails(props.item.id, 'edit')">
                        <v-icon class="material-icons orange--text" color="#bbbbc6">edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit Details</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <v-dialog v-model="match_object_dialog" persistent max-width="800px">
        <v-card>
          <v-card-title>
            <span class="headline">Match Details</span>
          </v-card-title>
          <v-card-text v-if="fetch_details == true">
            <v-progress-circular
                :size="70"
                :width="7"
                indeterminate
                color="#ff9233"
                class="text-xs-center"
                large
            ></v-progress-circular>
          </v-card-text>
          <v-card-text v-else-if="fetch_details == 'true1'">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <label>Date*: </label>
                  <v-text-field solo flat v-model="match_object[0].date" disabled></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 lg12 style="display: flex; flex-wrap: wrap;">
                  <v-flex xs12 sm12 md12 lg6 style="border-right: 1px solid #a1a0a0; margin-bottom: 10px;">
                    <v-flex xs12 sm12 md12>
                      <label>Team 1 Name*: </label>
                      <v-text-field
                          name="hack_related_to"
                          v-model="match_object[0].team_1_name"
                          v-validate="'required'"
                          solo flat disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label>Short Code Team 1*: </label>
                      <v-text-field
                          name="hack_related_to"
                          v-model="match_object[0].team_1_shortname"
                          v-validate="'required'"
                          solo flat disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label style="float: inline-start; margin-right: 10px;">Team 1 banner*: </label>
                      <img :src="match_object[0].team_1_img_url" width="80" height="80" alt=""/>
                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg6 style="border-left: 1px solid #a1a0a0; margin-bottom: 10px;">
                    <v-flex xs12 sm12 md12>
                      <label>Team 2 Name*: </label>
                      <v-text-field
                          name="hack_related_to"
                          v-model="match_object[0].team_2_name"
                          v-validate="'required'"
                          solo flat disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label>Short Code Team 2*: </label>
                      <v-text-field
                          name="hack_related_to"
                          v-model="match_object[0].team_2_shortname"
                          v-validate="'required'"
                          solo flat disabled></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label style="float: inline-start; margin-right: 10px;">Team 2 banner*: </label>
                      <img :src="match_object[0].team_2_img_url" width="80" height="80" alt=""/>

                    </v-flex>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="color: white" solo @click="match_object_dialog = false">Close
                </v-btn>
              </v-card-actions>
            </v-container>
          </v-card-text>

        </v-card>
      </v-dialog>

      <!--      //update match detalis-->
      <v-dialog v-model="update_match_object_dialog" persistent max-width="800px">
        <v-card>
          <v-form id="update_match"
                  @submit.prevent="validateBeforeSubmit('editMatch')"
                  data-vv-scope="editMatch"
                  ref="update_match_form"
                  v-model="valid">
            <v-card-title>
              <span class="headline">Match Details</span>
            </v-card-title>
            <v-card-text v-if="fetch_details == true">
              <v-progress-circular
                  :size="70"
                  :width="7"
                  indeterminate
                  color="#ff9233"
                  class="text-xs-center"
                  large
              ></v-progress-circular>
            </v-card-text>
            <v-card-text v-else-if="fetch_details == 'true1'">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <label>Date*: </label>
                    <v-text-field solo flat v-model="match_object[0].date"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg12 style="display: flex; flex-wrap: wrap;">
                    <v-flex xs12 sm12 md12 lg6 style="border-right: 1px solid #a1a0a0; margin-bottom: 10px;">
                      <v-flex xs12 sm12 md12>
                        <label>Team 1 Name*: </label>
                        <v-text-field
                            name="hack_related_to"
                            v-model="match_object[0].team_1_name"
                            v-validate="'required'"
                            solo flat></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <label>Short Code Team 1*: </label>
                        <v-text-field
                            name="hack_related_to"
                            v-model="match_object[0].team_1_shortname"
                            v-validate="'required'"
                            solo flat></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <label style="float: inline-start; margin-right: 10px;">Team 1 banner*: </label>
                        <img :src="match_object[0].team_1_img_url"
                             v-if="match_object[0].team_1_img_url != null"
                             width="50"
                             height="50" alt=""/>

                        <input type="file" name="previewImage2" class="form-control flatpickerCSS2" id="previewImage2"
                               accept="*/*"
                               @change="uploadImage($event,'update_img1')"
                               v-validate="'ext:jpg,jpeg,png'"/><br>
                        <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>


                      </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 lg6 style="border-left: 1px solid #a1a0a0; margin-bottom: 10px;">
                      <v-flex xs12 sm12 md12>
                        <label>Team 2 Name*: </label>
                        <v-text-field
                            name="hack_related_to"
                            v-model="match_object[0].team_2_name"
                            v-validate="'required'"
                            solo flat></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <label>Short Code Team 2*: </label>
                        <v-text-field
                            name="hack_related_to"
                            v-model="match_object[0].team_2_shortname"
                            v-validate="'required'"
                            solo flat></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <label style="float: inline-start; margin-right: 10px;">Team 2 banner*: </label>
                        <img :src="match_object[0].team_2_img_url"
                             v-if="match_object[0].team_2_img_url != null"
                             width="50" height="50" alt=""/>

                        <input type="file" name="previewImage2" class="form-control flatpickerCSS2" id="previewImage2"
                               accept="*/*"
                               @change="uploadImage($event,'update_img2')"
                               v-validate="'ext:jpg,jpeg,png'"/><br>
                        <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                      </v-flex>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" style="color: white" solo @click="update_match_object_dialog = false">Close
              </v-btn>
              <v-btn color="blue darken-1" style="color: white" solo @click="editMatch()">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>


      <!--      //create match-->
      <v-dialog v-model="create_match_object_dialog" persistent max-width="800px">
        <v-card>
          <v-form id="create_match"
                  @submit.prevent="validateBeforeSubmit('createMatch')"
                  data-vv-scope="createMatch"
                  ref="create_match_form"
                  v-model="valid">
            <v-card-title>
              <span class="headline">Create Match</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <label>Date*: </label>
                    <v-text-field solo flat v-model="match_details.date" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <label>Match Order*: </label>
                    <v-autocomplete
                        v-model="match_details.match_order"
                        :items="match_orders"
                        item-value="value"
                        item-text="text"
                        clearable solo flat
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12>
                    <v-flex xs12 sm12 md12>
                      <label>Team 1 Name*: </label>
                      <v-autocomplete
                          v-model="match_details.team_1_name"
                          :items="iplTeamList"
                          placeholder="Search By Team name"
                          item-value="team_1_shortname"
                          :item-text="getTeamName"
                          clearable solo flat
                          :search-input.sync="search_title"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label style="float: inline-start; margin-right: 10px;">Team 1 banner*: </label>
                      <input type="file" name="previewImage" class="form-control flatpickerCSS2" id="previewImage"
                             accept="*/*"
                             @change="uploadImage($event,'create_img1')"
                             v-validate="'ext:jpg,jpeg,png'"/><br>
                      <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>

                    </v-flex>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg12>
                    <v-flex xs12 sm12 md12>
                      <label>Team 2 Name*: </label>
                      <v-autocomplete
                          v-model="match_details.team_2_name"
                          :items="iplTeamList"
                          placeholder="Search By Team name"
                          item-value="team_1_shortname"
                          :item-text="getTeamName"
                          clearable solo flat
                          :search-input.sync="search_title2"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label style="float: inline-start; margin-right: 10px;">Team 2 banner*: </label>
                      <input type="file" name="previewImage1" class="form-control flatpickerCSS2" id="previewImage1"
                             accept="*/*"
                             @change="uploadImage($event,'create_img2')"
                             v-validate="'ext:jpg,jpeg,png'"/><br>
                      <span style="font-size: 11px;">(Allowed file types: jpg,jpeg,png)</span>
                    </v-flex>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" style="color: white" @click="create_match_object_dialog = false">Close</v-btn>
              <v-btn color="primary" style="color: white" @click="createMatch()"
                     :disabled="(
                     match_details.date == undefined ||
                     match_details.team_1_name == undefined ||
                     match_details.team_2_name == undefined)">Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>


      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout">
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Index",
  watch: {
    search_title: {
      handler(newVal) {
        if (newVal != null && newVal != undefined && this.match_details.team_2_name != undefined) {
          if (this.match_details.team_1_name == this.match_details.team_2_name) {
            alert("Team can not be same");
            this.match_details.team_1_name = this.match_details.team_1_shortname =
                this.match_details.team_2_name = this.match_details.team_1_shortname = "";
          }
        }
      },
    },
    search_title2: {
      handler(newVal) {
        if (newVal != null && newVal != undefined && this.match_details.team_1_name != undefined) {
          if (this.match_details.team_2_name == this.match_details.team_1_name) {
            alert("Team can not be same");
            this.match_details.team_1_name = this.match_details.team_1_shortname =
                this.match_details.team_2_name = this.match_details.team_1_shortname = "";
          }
        }
      },
    },
  },
  methods: {
    getMatchList() {
      this.iplMatchesList = [];
      this.loaders.IPL_matches_list = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-ipl-matches`, {
        params: this.pagination
      }).then((response) => {
        if (response.data.status == 1) {
          this.loaders.IPL_matches_list = false;
          this.iplMatchesList = response.data.data;
          this.total_items = response.data.data.total;
        } else if (response.data.status == 0) {
          this.loaders.IPL_matches_list = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      });
    },
    getTeamList() {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-teams`, {
        params: this.pagination
      }).then((response) => {
        if (response.data.status == 1) {
          this.iplTeamList = response.data.data;
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      });
    },
    getMatchDetails(id, type) {
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/show-match-details/` + id).then((response) => {

        if (response.data.status == 1) {
          this.match_object = response.data.data;
          if (type == "show") {
            this.fetch_details = "true1";
            this.match_object_dialog = true;
          } else if (type == 'edit') {
            this.fetch_details = "true1";
            this.update_match_object_dialog = true;
          }
        } else if (response.data.status == 0) {
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      });
    },
    showDetails(id, type = "show") {
      this.fetch_details = true;
      this.getMatchDetails(id, type);
    },
    editMatch() {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-ipl-match`,
          this.match_object[0],
          {headers: this.$headers,})
          .then((response) => {
            if (response.data.status == 1) {
              this.update_match_object_dialog = false;
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true
              this.getMatchList();
            } else if (response.data.status == 0) {
              this.update_match_object_dialog = false;
              this.stopLoading();
            }
          }).catch((error) => {
        this.stopLoading();
        this.update_match_object_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    createMatch() {
      this.startLoading();

      const team1 = this.iplTeamList.find(team => team.team_1_shortname === this.match_details.team_1_name);
      const team2 = this.iplTeamList.find(team => team.team_1_shortname === this.match_details.team_2_name);

      this.match_details.team_1_name = team1.team_1_name;
      this.match_details.team_2_name = team2.team_1_name;
      this.match_details.team_1_shortname = team1.team_1_shortname;
      this.match_details.team_2_shortname = team2.team_1_shortname;

      let result = Object.assign({}, this.match_details)
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/create-ipl-match`, result)
          .then((response) => {
            if (response.data.status == 1) {
              this.create_match_object_dialog = false;
              this.stopLoading();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true
              this.getMatchList();
            } else if (response.data.status == 0) {
              this.create_match_object_dialog = false;
              this.stopLoading();
            }
          }).catch((error) => {
        this.stopLoading();
        this.create_match_object_dialog = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    validateBeforeSubmit(scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      })
    },
    uploadImage(e,type) {
      const image_path = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image_path);
      reader.onload = e => {
        if(type == 'create_img1'){
          this.match_details.team_1_img_url = e.target.result;
        }else if(type == 'create_img2'){
          this.match_details.team_2_img_url = e.target.result;
        }else if(type == 'update_img1'){
          this.match_object[0].team_1_img_url = e.target.result;
        }else if(type == 'update_img2'){
          this.match_object[0].team_2_img_url = e.target.result;
        }
      };
    },
    getTeamName(item){
      return `${item.team_1_name} ( ${item.team_1_shortname} )`
    }
  },
  data() {
    return {
      total_items: 0,
      pageLoader: false,
      loaders: {
        IPL_matches_list: false,
      },
      iplMatchesList: [],
      iplTeamList: [],
      selected: [],
      match_object: [],
      match_object_dialog: false,
      update_match_object_dialog: false,
      create_match_object_dialog: false,
      headers: [
        {text: "Match Date", value: "date", sorted: true},
        {text: "Team 1", value: "team_1_name", sorted: false},
        {text: "Team 2", value: "team_2_name", sorted: false},
        {text: "Match Order", value: "first_name", sorted: false},
        {text: "Action", value: "action"},
      ],
      pagination: {sortBy: "date", descending: true, rowsPerPage: 10},
      fetch_details: false,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      valid: '',
      match_details: [
        {match_order: "1"}
      ],
      search_title: '',
      search_title2: "",
      match_orders: [
        {text: '1', value: "1"},
        {text: '2', value: "2"}
      ]
    }
  },
  mounted() {
    this.getMatchList();
    this.getTeamList();
  }
}
</script>

<style scoped>

</style>
